import { useState } from "react";

import regexp from "common/Regexp";
import { PrimaryButton } from "components/button/Button";
import { Input, Label } from "components/input/Input";

import "./EmailSubmitForm.scss";

type Props = {
  triggerAction: (email: string) => void;
};

export default function EmailSubmitForm({ triggerAction }: Props) {
  const [email, setEmail] = useState("");
  const [clicked, setClicked] = useState(false);

  const isValidEmail = () => {
    return email.match(regexp.email);
  };

  const isLudvigEmail = () => {
    const userEmail = email.toLowerCase();
    return (
      isValidEmail() &&
      (userEmail.includes("@ludvig.se") || userEmail.includes("@lrfkonsult.se"))
    );
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setClicked(true);
    triggerAction(email);
  };

  return (
    <form onSubmit={(e) => handleSubmit(e)}>
      {email.length > 0 && !isValidEmail() && (
        <div className="errorMessage">Ogiltig e-postadress</div>
      )}

      {isLudvigEmail() && (
        <div className="errorMessage">
          Ogiltig e-postadress. Endast kundanvändare kan använda
          funktionaliteten.
        </div>
      )}

      <Label htmlFor="email">Ange e-postadress</Label>
      <Input
        disabled={clicked}
        className="mb-5"
        name="email"
        type="text"
        value={email}
        placeholder="E-postaddress"
        onChange={(e) => setEmail(e.target.value.trim())}
      />

      <PrimaryButton disabled={!isValidEmail() || clicked} type="submit">
        Skicka länk
      </PrimaryButton>
    </form>
  );
}
